import React from 'react';

export type HomeIconProps = React.HTMLProps<SVGSVGElement>;

export function HomeIcon({ ...props }: HomeIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <g id="Group_24490" data-name="Group 24490" transform="translate(-865 -172)">
        <g
          id="Rectangle_10299"
          data-name="Rectangle 10299"
          transform="translate(865 172)"
          fill="#fff"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="24" height="24" stroke="none" />
          <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
        </g>
        <path
          id="Path_41477"
          data-name="Path 41477"
          d="M344.5,1415.27v-6.716a2.206,2.206,0,0,1,.1-.953.883.883,0,0,1,.4-.4,2.279,2.279,0,0,1,.966-.1h2.567a2.279,2.279,0,0,1,.966.1.884.884,0,0,1,.4.4,2.206,2.206,0,0,1,.1.953v6.716m-3.65-16.555-6.218,4.792a3.9,3.9,0,0,0-.773.681,1.714,1.714,0,0,0-.292.59A3.9,3.9,0,0,0,339,1405.8v6.562a4.483,4.483,0,0,0,.2,1.915,1.841,1.841,0,0,0,.8.79,4.56,4.56,0,0,0,1.932.2h10.633a4.56,4.56,0,0,0,1.932-.2,1.841,1.841,0,0,0,.8-.79,4.484,4.484,0,0,0,.2-1.915V1405.8a3.9,3.9,0,0,0-.068-1.026,1.714,1.714,0,0,0-.292-.59,3.905,3.905,0,0,0-.773-.681l-6.218-4.792a2.128,2.128,0,0,0-.661-.418,1.063,1.063,0,0,0-.478,0A2.129,2.129,0,0,0,346.35,1398.715Z"
          transform="translate(529.75 -1223.27)"
          fill="rgba(0,0,0,0)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
      </g>
    </svg>
  );
}
